module.exports = __webpack_public_path__ + "static/media/neurodiversity.7627875d.jpg";